import { useEffect, useState } from 'react'
import { STORAGE_CONST, LANGUAGE_CODES } from '@common/constants'
import { saveSessionState, getSessionState } from '@common/utils'

export const useLanguageInPathName = () => {
    const storedLanguage = getSessionState(STORAGE_CONST.SAVED_LANGUAGE)
    const urlSplitForLang = window.location.pathname.split('/')[1]
    const hasLang = Object.values(LANGUAGE_CODES).includes(urlSplitForLang)
    const urlLang = hasLang && urlSplitForLang !== 'en' ? `/${urlSplitForLang}` : ''
    const [didRedirect, setDidRedirect] = useState(false)

    useEffect(() => {
        // If we get language tag from the url, then respect that language and set it to the storage language to update the content
        if (urlLang && !storedLanguage) {
            saveSessionState(STORAGE_CONST.SAVED_LANGUAGE, urlSplitForLang)
        }

        // If we get language tag from the url and there's a stored language, then respect the stored language and replace the language tag in url
        if (urlLang && storedLanguage && storedLanguage !== urlSplitForLang) {
            setDidRedirect(true)
            window.location.pathname = window.location.pathname.replace(
                urlLang,
                `${storedLanguage !== 'en' ? `/${storedLanguage}` : ''}`
            )
        }

        // If no language tag from the url and there's a stored language, then respect the stored language and replace the language tag in url
        if (!urlLang && storedLanguage && storedLanguage !== 'en') {
            setDidRedirect(true)
            window.location.pathname = window.location.pathname.replace('', `/${storedLanguage}`)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storedLanguage, urlLang])

    return { urlLang, didRedirect }
}
